import { render } from "./_Pagination.vue?vue&type=template&id=10badd87&scoped=true"
import script from "./_Pagination.vue?vue&type=script&lang=js"
export * from "./_Pagination.vue?vue&type=script&lang=js"

import "./_Pagination.vue?vue&type=style&index=0&id=10badd87&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10badd87"

export default script